import { render, staticRenderFns } from "./automatic.vue?vue&type=template&id=566fb4aa&scoped=true"
import script from "./automatic.vue?vue&type=script&lang=js"
export * from "./automatic.vue?vue&type=script&lang=js"
import style0 from "./automatic.vue?vue&type=style&index=0&id=566fb4aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566fb4aa",
  null
  
)

export default component.exports